import { RESET_FX_ADD_TRANSACTION_PAYMENT_METHOD } from 'constants/fx';
import React, { useEffect, useState } from 'react';

const initialFormField = RESET_FX_ADD_TRANSACTION_PAYMENT_METHOD;

const withFxMakePayment = (Component) => {
  const FxMakePaymentComponent = (props) => {
    const [information, setInformation] = useState(initialFormField);
    const [validation, setValidation] = useState(initialFormField);
    const [informationChangeBackup, setInformationChangeBackup] =
      useState(null);

    const { isAllowOrderMakePayment } = props || {};

    useEffect(() => {
      if (!isAllowOrderMakePayment) return;
    }, [isAllowOrderMakePayment]);

    const newProps = {
      initialFormField,
      information,
      setInformation,
      validation,
      setValidation,
      informationChangeBackup,
      setInformationChangeBackup,
      ...props,
    };
    return <Component {...newProps} />;
  };
  return FxMakePaymentComponent;
};

export default withFxMakePayment;
